import { Box, Typography } from "@mui/material";
import { Phone, MessageSquare, Mail } from "lucide-react";

const FutureAdvisorInfo = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        backgroundColor: "#FFFFFF",
        borderRadius: "12px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            letterSpacing: "-0.36px",
          }}
        >
          Family Advisor
        </Typography>

        <Box
          sx={{
            display: "flex",
            gap: "16px",
            alignItems: "flex-start",
          }}
        >
          <Box
            component="img"
            src="/assets/images/FadedFace.jpg"
            alt="Your Future Advisor"
            sx={{
              width: "57px",
              height: "57px",
              borderRadius: "100px",
              border: "1px solid #D4D4D4",
              objectFit: "cover",
              flexShrink: 0,
            }}
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              flex: 1,
            }}
          >
            <Typography
              variant="bodyHeavy"
              sx={{
                color: "#6B6E7B",
                letterSpacing: "-0.15px",
              }}
            >
              Your Future Advisor
            </Typography>

            <Box
              sx={{
                display: "flex",
                gap: "20px",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: "6px",
                  alignItems: "center",
                }}
              >
                <Phone height="16px" width="16px" color="#8E9598" />
                <Typography
                  variant="bodySmall"
                  sx={{
                    color: "#8E9598",
                    fontWeight: 600,
                    lineHeight: "141%",
                  }}
                >
                  Call
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  gap: "6px",
                  alignItems: "center",
                }}
              >
                <MessageSquare height="16px" width="16px" color="#8E9598" />
                <Typography
                  variant="bodySmall"
                  sx={{
                    color: "#8E9598",
                    fontWeight: 600,
                    lineHeight: "141%",
                  }}
                >
                  Text
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  gap: "6px",
                  alignItems: "center",
                }}
              >
                <Mail height="16px" width="16px" color="#8E9598" />
                <Typography
                  variant="bodySmall"
                  sx={{
                    color: "#8E9598",
                    fontWeight: 600,
                    lineHeight: "141%",
                  }}
                >
                  Email
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box sx={{ display: "flex", gap: "23px" }}>
          <Typography
            variant="body"
            sx={{
              letterSpacing: "-0.15px",
              flex: 1,
            }}
          >
            After you sign up, you'll get a text from your Advisor. Save their
            contact info and start sending over the tasks you want off your
            plate.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default FutureAdvisorInfo;
